export let UploadState = /*#__PURE__*/function (UploadState) {
  UploadState["IDLE"] = "idle";
  UploadState["LOADING"] = "loading";
  UploadState["ERROR"] = "error";
  UploadState["COMPLETE"] = "complete";
  return UploadState;
}({});
//# sourceMappingURL=types.js.map